import { AsyncPipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormFieldComponent, FormFieldNewComponent, ModalComponent, SdvorButtonComponent } from '@sdvor/shared/ui';
import {
  DropdownComponent,
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  DropdownTogglerComponent,
} from '@sdvor/shared/ui/v2';
import { YandexMapModule } from '@sdvor/yandex-maps/ui';
import { FormErrorsComponent, IconModule } from '@spartacus/storefront';
import { SdvorDeliveryActiveAddressComponent } from './delivery-active-address/delivery-active-address.component';
import { SdvorDeliveryAddAddressComponent } from './delivery-add-address/delivery-add-address.component';
import { SdvorDeliveryAddressBlockComponent } from './delivery-address-block.component';
import { SdvorDeliveryAddressDialogModule } from './delivery-address-dialog';
import { SdvorDeliveryAddressListModalComponent } from './delivery-address-list-modal/delivery-address-list-modal.component';
import { SdvorDeliveryAddressListComponent } from './delivery-address-list/delivery-address-list.component';
import { SdvorDeliveryAddressComponent } from './delivery-address/delivery-address.component';

@NgModule({
  declarations: [
    SdvorDeliveryAddressBlockComponent,
    SdvorDeliveryActiveAddressComponent,
    SdvorDeliveryAddAddressComponent,
    SdvorDeliveryAddressListModalComponent,
    SdvorDeliveryAddressListComponent,
    SdvorDeliveryAddressComponent,
  ],
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    NgClass,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    ModalComponent,
    FormFieldComponent,
    FormFieldNewComponent,
    YandexMapModule,
    NgbTooltipModule,
    IconModule,
    FormErrorsComponent,
    SdvorDeliveryAddressDialogModule,
    ReactiveFormsModule,
    SdvorButtonComponent,
    DropdownComponent,
    DropdownTogglerComponent,
    DropdownMenuComponent,
    DropdownMenuItemComponent,
  ],
  exports: [SdvorDeliveryAddressBlockComponent],
})
export class SdvorDeliveryAddressModule {}
